/**
 * 区域管理
 */
<template>
  <div>
    <!-- 引入任务管理 -->
    <div v-show="See">
      <task ref="child" :areaName="areaName" />
      <div @click="close()">
        <img class="close" src="../../assets/img/close.png" />
      </div>
    </div>
    <div v-show="isShow" style="margin: 20px">
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home_page/home_Page' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>区域管理</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 搜索筛选 -->
      <el-form :inline="true" :model="formInline" style="margin-top: 20px; heigth: 60px">
        <el-form-item label="区域名称:">
          <el-input size="small" v-model="formInline.name" @keyup.enter.native="search()" placeholder="输入区域名称"
            clearable></el-input>
        </el-form-item>
        <el-form-item label="负责人" prop="head">
          <el-select v-model="formInline.head" clearable filterable placeholder="请选择负责人" size="small" style="width: 100%">
            <el-option v-for="item in personCharge" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
        <!-- <el-button
            size="small"
            type="primary"
            icon="el-icon-plus"
                              @click="handleAdd()"
                              >添加</el-button
                            > -->
        </el-form-item>
      </el-form>
      <!--列表-->
      <el-table :data="listData" border element-loading-text="拼命加载中" style="width: 100%">
        <el-table-column align="center" label-aligin="center" prop="id" fixed label="ID" width="80"></el-table-column>
        <el-table-column align="center" label-aligin="center" prop="name" min-width="250" label="区域名称">
        </el-table-column>
        <el-table-column align="center" label-aligin="center" prop="line_count" min-width="150" label="区域线路数">
        </el-table-column>
        <el-table-column align="center" label-aligin="center" prop="car_count" min-width="150" label="区域车辆数">
        </el-table-column>
        <el-table-column align="center" label-aligin="center" prop="headUser.name" min-width="150" label="负责人">
          <template slot-scope="scope">
            <div v-if="scope.row.headUser">{{ scope.row.headUser.name }}</div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label-aligin="center" prop="guardianUsers" min-width="250" label="安全员">
          <template slot-scope="scope">
            <div v-if="scope.row.guardianUsers">{{ scope.row.guardianUsers }}</div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column align="center" label-aligin="center" prop="create_time" min-width="300" label="创建时间">
        </el-table-column>
        <el-table-column align="center" label-aligin="center" label="操作" fixed="right" width="200">
          <template slot-scope="scope">
            <el-button round size="mini" type="warning" @click="task(scope.row)"
              v-if="check_auth('/web/task/get_list') || check_auth('/web/area/get_area_line') || check_auth('/web/area/get_area_cars')">
              任务管理</el-button>
          <el-button round size="mini" type="primary" @click="handleEdit(scope.row)"
            v-if="check_auth('/web/area/edit')">编辑</el-button>
          <!-- <el-button
              round
              size="mini"
              type="danger"
                                @click="delRegion(scope.row)"
                                >删除</el-button
                              > -->
            <!-- <el-button size="mini" @click="handleOperation(scope.row)">操作</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 添加界面 -->
    <!-- <el-dialog
        title="添加"
        :visible.sync="addFormVisible"
        width="30%"
        @click="closeDialog"
        :destroy-on-close="true"
        :close-on-click-modal="false"
      >
        <div style="margin-right: 5%">
          <el-form
            label-width="80px"
            :model="addForm"
            :rules="rules"
            ref="addForm"
          >
            <el-form-item label="区域名称" prop="name">
              <el-input
                size="small"
                v-model="addForm.name"
                auto-complete="off"
                placeholder="请输入区域名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="负责人" prop="head">
              <el-select
                v-model="addForm.head"
                clearable
                placeholder="请选择负责人"
                size="small"
                style="width: 100%"
              >
                <el-option
                  v-for="item in addPersonCharge"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="安全员" prop="guardian">
              <el-select
                style="width: 100%"
                v-model="addForm.guardian"
                multiple
                placeholder="请选择安全员"
                size="small"
              >
                <el-option
                  v-for="item in addGuardian"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input
                size="small"
                type="textarea"
                v-model="addForm.remark"
                auto-complete="off"
                placeholder="请输入备注"
              ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button
              size="small"
              type="primary"
              :loading="loading"
              @click="submitAddForm('addForm')"
              >保存</el-button
            >
            <el-button size="small" @click="closeDialog('addForm')"
              >取消</el-button
            >
                            </div>
                          </div>
                        </el-dialog> -->
      <!-- 编辑界面 -->
      <el-dialog title="修改" :visible.sync="dialogVisible" width="35%">
        <el-form label-width="13%" :model="editForm" :rules="rules" ref="editForm">
          <el-form-item label="区域名称">
            <el-input size="small" v-model="editForm.name" auto-complete="off" disabled placeholder="请输入区域名称">
            </el-input>
          </el-form-item>
          <el-form-item label="区域线路数">
            <el-input size="small" v-model="editForm.line_count" auto-complete="off" disabled placeholder="请输入区域线路数">
            </el-input>
          </el-form-item>
          <el-form-item label="区域车辆数" prop="car_count">
            <el-input size="small" v-model="editForm.car_count" disabled auto-complete="off" placeholder="请输入区域车辆数">
            </el-input>
          </el-form-item>
          <el-form-item label="负责人" prop="head">
            <el-select v-model="editForm.head" clearable placeholder="请选择负责人" filterable size="small" style="width: 100%">
              <el-option v-for="item in editPersonCharge" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="安全员" prop="guardian">
            <el-select style="width: 100%" v-model="editForm.guardian" filterable multiple placeholder="请选择安全员"
              size="small">
              <el-option v-for="item in editGuardian" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间" prop="create_time">
            <el-date-picker style="width: 100%" v-model="editForm.create_time" type="datetime" placeholder="选择日期时间"
              default-time="12:00:00" value-format="yyyy-MM-dd HH:mm:ss" disabled>
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" type="primary" :loading="loading" @click="submitForm('editForm')">保存</el-button>
          <el-button size="small" @click="closeDialog()">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  get_region_list,
  get_customer_users_list,
  get_region_one,
  get_region_edit,
} from "../../api/region/region";
import {
  auth
} from "../../utils/util";
import Pagination from "../../components/Pagination";
import task from "../region_mn/task_mn";
export default {
  data() {
    return {
      value1: "",
      areaName: "",
      See: false,
      isShow: true,
      Show: false,
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      // addFormVisible: false,
      dialogVisible: false,
      personCharge: [],
      // addPersonCharge: [],
      editPersonCharge: [],
      // addGuardian: [],
      editGuardian: [],
      // addForm: {
      //   id: "",
      //   name: "",
      //   line_count: "",
      //   car_count: "",
      //   create_time: "",
      //   personCharge: "",
      //   guardian: "",
      //   remark: "",
      // },
      editForm: {
        id: "",
        name: "",
        line_count: "",
        car_count: "",
        create_time: "",
        head: "",
        guardian: "",
      },
      // rules表单验证
      rules: {
        name: [{ required: true, message: "请输入区域名称", trigger: "blur" }],
        line_count: [
          { required: true, message: "请输入区域编号", trigger: "blur" },
        ],
        head: [{ required: true, message: "请输入区域编号", trigger: "blur" }],
        guardian: [
          { required: true, message: "请输入区域编号", trigger: "blur" },
        ],
      },
      formInline: {
        id: "",
        name: "",
        head: "",
        page: 1,
        limit: 10,
      },
      listData: [],
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
    task,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getData();
    this.getHead();
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 跳转任务管理界面
    task(row) {
      window.localStorage.setItem("area_id", row.id);
      this.areaName = row.name
      this.isShow = false;
      this.See = true;
      this.$refs.child.$emit("childmethod");
      // this.$router.push("/area_mn/task_mn");
    },
    // 关闭任务管理界面
    close() {
      this.isShow = true;
      this.See = false;
      this.getData();
      this.$refs.child.clear();
      window.localStorage.removeItem("area_id");
    },
    // 添加负责人
    getHead() {
      get_customer_users_list().then((res) => {
        if (res["code"] === 0) {
          this.personCharge = res.data;
        }
      });
    },
    check_auth(val) {
      return auth(val);
    },
    // 获取区域列表
    getData() {
      get_region_list(this.formInline).then((res) => {
        if (res["code"] === 0) {
          // this.loading = false;
          this.listData = res.data.data;
          for (let i = 0; i < this.listData.length; i++) {
            let time = this.listData[i].create_time;
            // this.listData[i].create_time = timestampToTime(time * 1000);
          }
          this.pageparm.currentPage = this.formInline.page;
          this.pageparm.pageSize = this.formInline.limit;
          this.pageparm.total = res.data["total"];
        }
      });
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getData();
    },
    // 搜索事件
    search() {
      this.formInline.page = 1;
      this.getData();
    },
    // // 添加负责人
    // getAddHead() {
    //   get_customer_users_list().then((res) => {
    //     if (res["code"] === 0) {
    //       this.addPersonCharge = res.data;
    //     }
    //   });
    // },
    // // 添加安全员
    // getAddGuardian() {
    //   get_customer_users_list().then((res) => {
    //     if (res["code"] === 0) {
    //       this.addGuardian = res.data;
    //     }
    //   });
    // },
    // //添加界面
    // handleAdd() {
    //   this.addFormVisible = true;
    //   this.getAddHead();
    //   this.getAddGuardian();
    //   this.addForm = {};
    // },
    // // 添加页面保存方法
    // submitAddForm(addData) {
    //   let ids = [];
    //   for (var i = 0; i < this.addForm.guardian.length; i++) {
    //     ids.push(this.addForm.guardian[i]);
    //   }
    //   var str = ids.join(",");
    //   this.$refs[addData].validate((valid) => {
    //     if (valid) {
    //       get_region_add(this.addForm, str).then((res) => {
    //         if (res["code"] === 0) {
    //           this.$message.success(res["message"]);
    //           this.getData();
    //           this.addForm = {};
    //           this.addFormVisible = false;
    //         }
    //       });
    //     }
    //   });
    // },
    // 编辑负责人
    getEditHead() {
      get_customer_users_list().then((res) => {
        if (res["code"] === 0) {
          this.editPersonCharge = res.data;
        }
      });
    },
    // 编辑安全员
    getEditGuardian() {
      get_customer_users_list().then((res) => {
        if (res["code"] === 0) {
          this.editGuardian = res.data;
        }
      });
    },
    // 显示编辑界面
    handleEdit(row) {
      this.editForm = {};
      this.dialogVisible = true;
      this.getEditHead();
      this.getEditGuardian();
      get_region_one(row.id).then((res) => {
        if (res["code"] === 0) {
          this.editForm = res.data;
          this.editForm.head = res.data.head.id
        }
      });
    },
    // 编辑页面保存方法
    submitForm(editData) {
      let ids = [];
      for (var i = 0; i < this.editForm.guardian.length; i++) {
        ids.push(this.editForm.guardian[i]);
      }
      var str = ids.join(",");
      this.$refs[editData].validate((valid) => {
        if (valid) {
          get_region_edit(this.editForm, str).then((res) => {
            this.dialogVisible = false;
            this.loading = false;
            if (res["code"] === 0) {
              this.getData();
              this.$message.success(res["message"]);
            }
          });
        }
      });
    },
    // 删除区域
    // delRegion(row) {
    //   this.$confirm("确定要删除吗?", "信息", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     closeOnClickModal: false,
    //     type: "warning",
    //   })
    //     .then(() => {
    //       get_del_area(row.id).then((res) => {
    //         if (res["code"] === 0) {
    //           this.$message.success(res["message"]);
    //           if (this.listData.length === 1) {
    //             if (this.formInline.page === 1) {
    //               this.getData();
    //             } else {
    //               this.formInline.page = this.formInline.page - 1;
    //               this.getData();
    //             }
    //           } else {
    //             this.getData();
    //           }
    //         }
    //       });
    //     })
    //     .catch(() => {
    //       this.$message({
    //         type: "info",
    //         message: "已取消删除",
    //       });
    //     });
    // },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.dialogVisible = false;
      // this.addFormVisible = false;
    },
  },
};
</script>

<style scoped>
.close {
  width: 1.5%;
  height: 2.5%;
  position: absolute;
  top: 8%;
  left: 97%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/region_mn/Region_mn.vue